/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ===== 1. Hulp: prijs uit .price-list halen =====
function getCurrentProductPrice() {
  const priceList = document.querySelector('.price-list');
  if (!priceList) return null;

  // Eerst proberen: aanbieding – highlight prijs
  let priceEl = priceList.querySelector('.price.price--highlight');

  // Geen aanbieding? Dan de "normale" price-span pakken
  if (!priceEl) {
    priceEl = priceList.querySelector('.price');
  }

  if (!priceEl) return null;

  const rawText = priceEl.textContent.trim(); // bv. "€199,00 EUR" of "€699,00 EUR"

  // Alleen cijfers, punten, komma's, min-teken
  let cleaned = rawText.replace(/[^\d.,-]/g, ''); // "199,00" of "1.016,00"

  // Als er én '.' én ',' in zitten → '.' is duizendtalseparator
  if (cleaned.indexOf('.') !== -1 && cleaned.indexOf(',') !== -1) {
    cleaned = cleaned.replace(/\./g, ''); // "1016,00"
  }

  // Komma → punt voor parseFloat
  cleaned = cleaned.replace(',', '.'); // "1016.00"

  const number = parseFloat(cleaned);
  if (isNaN(number)) return null;

  return number;
}

// ===== 2. Tekst voor één in3-label updaten =====
function updateSingleIn3Label(container) {
  if (!container) return;

  const textEl = container.querySelector('.in3__text');
  const infoEl = container.querySelector('.in3__info-text');

  if (!textEl) return;

  const priceNumber = getCurrentProductPrice();
  if (priceNumber === null) return;

  // 1/3 van de prijs
  const instPrice = priceNumber / 3;

  // NL-notatie met €x.xxx,xx
  const formatted = instPrice.toLocaleString('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const amount = '€' + formatted;

  // Korte NL-tekst
  const nlShort = `Of betaal 3 termijnen van ${amount}`;
  textEl.textContent = nlShort;

  // Lange uitlegtekst (NL)
  if (infoEl) {
    infoEl.textContent =
      'Betaal vandaag de eerste termijn via iDEAL met in3. ' +
      'De tweede en derde termijn betaal je binnen 30 en 60 dagen. ' +
      'Zonder rente en zonder BKR-registratie.';
  }
}

// ===== 3. Alle in3-labels op de pagina updaten =====
function updateAllIn3Labels() {
  const containers = document.querySelectorAll('[id^="in3-label-"]');
  containers.forEach(updateSingleIn3Label);
}

// ===== 4. Alles initialiseren en events koppelen =====
function initIn3DynamicLabels() {
  // Direct bij init
  updateAllIn3Labels();

  const form = document.querySelector('form.product-form');

  // a) Form changes (varianten, opties, select-elementen, etc.)
  if (form && !form.__in3DynamicLabelsBound) {
    form.addEventListener('change', function () {
      updateAllIn3Labels();
    });
    form.__in3DynamicLabelsBound = true;
  }

  // b) Quantity input
  const qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput && !qtyInput.__in3DynamicLabelsBound) {
    const handler = function () {
      // kleine delay zodat prijs eerst door het theme/app wordt bijgewerkt
      setTimeout(updateAllIn3Labels, 50);
    };
    qtyInput.addEventListener('input', handler);
    qtyInput.addEventListener('change', handler);
    qtyInput.__in3DynamicLabelsBound = true;
  }

  // c) Plus/min knoppen van de quantity-picker
  const qtyButtons = document.querySelectorAll(
    'button[data-action="increase-picker-quantity"], button[data-action="decrease-picker-quantity"]'
  );
  qtyButtons.forEach(function (btn) {
    if (!btn.__in3DynamicLabelsBound) {
      btn.addEventListener('click', function () {
        setTimeout(updateAllIn3Labels, 50);
      });
      btn.__in3DynamicLabelsBound = true;
    }
  });

  // d) Extra kleine retry voor het geval de prijs iets later komt
  setTimeout(updateAllIn3Labels, 300);
}

// ===== 5. Events koppelen =====
document.addEventListener('DOMContentLoaded', initIn3DynamicLabels);
document.addEventListener('shopify:section:load', initIn3DynamicLabels);
